import TemplateKey = Utils.TemplateKey;
import type {BoolEx} from "@/modules/budget/staffing-table/reports/types";

/**
 * TODO old name - IBudgetVariant
 */
export interface BudgetVariants {
    id: number | null;
    nameRu: string;
    nameKk: string | null;
    nameEn: string | null;
    variantUuid: string;
    year: number | null;
    dataType: number | null;
    attribute: boolean | null;
    status: boolean;
    basisRu: string | null;
    dateTime: number | null;
    isDeleted: boolean;
    prevVariant: string | null;
    nextVariant: string | null;
    regionCode: string | null;
    dateUeb: number | null;
    dateAbp: number | null;
    basisKk: string | null;

    /** Дата создания версии */
    dateStart: number | null;
    updateDate: number | null;
    userName: string | null;
}

/**
 * Для сводных отчетов
 */
export namespace SummaryReport {
    /** Сводные отчеты */
    export interface ReportTask {
        id: number;
        generatorType: GeneratorTypeEnum,
        region: string | null;
        dataType: string | null;
        eduOrgType: string | null;
        codeGu: string | null;
        subGuCodes: Array<string>;
        abp: number;
        variantUuid: string;
        budgetProgram: number | null;
        staffTabVersion: number | null;
        isEducation: boolean | null;
        detailedReport: boolean;
        includeDepartment: boolean;
        status: EnumStatus;
        progress: number;
        year: number,
        createDate: Date | null,
        exportDate: Date | null
        userId: string;
        userName: string;
    }

    export type Status = 'NEW' | 'IN_PROGRESS' | 'FAILED' | 'SUCCESSFUL' | 'EXPORTED';
    export enum EnumStatus {
        NEW = 'NEW',
        IN_PROGRESS = 'IN_PROGRESS',
        FAILED = 'FAILED',
        SUCCESSFUL = 'SUCCESSFUL',
        EXPORTED = 'EXPORTED',
        RETRYING = 'RETRYING',
        CANCEL_REQUESTED = 'CANCEL_REQUESTED',
        TASK_CANCELED = 'TASK_CANCELED',
        RESTORE_DTO_BROKEN = 'RESTORE_DTO_BROKEN',
        IN_REPAIRING = 'IN_REPAIRING',
        FAILED_REPAIR = 'FAILED_REPAIR',
        SUCCESS_REPAIR = 'SUCCESS_REPAIR'
    }

    export enum GeneratorTypeEnum {
        /** Сводный отчет - штатное расписание  */
        SVD_ORG_UO = 'SVD_ORG_UO',

        /** Сводный отчет - тарификация образование 360 */
        SVD_ORG_TC = 'SVD_ORG_TC',

        /** Сводный отчет - тарификация образование 261 */
        SVD_EDU = 'SVD_EDU',

        /** Сводный отчет - штатное расписание тарификация 261*/
        SVD_EDU_SHR = 'SVD_EDU_SHR',

        /** Сводный отчет - КГКП  */
        SVD_KGKP = 'SVD_KGKP',

        /** Сводный отчет - индивидуальный  */
        SVD_IND = 'SVD_IND',

        /** Сводный отчет - управление образованием  */
        SVD_EDU_UNIFIED  = 'SVD_EDU_UNIFIED',
    }

}

/** Типы для компонентов */
export namespace Comp {
    /**
     * Варианты цветов:
     * * `'primary'`
     * * `'secondary'`
     * * `'success'`
     * * `'danger'`
     * * `'warning'`
     * * `'info'`
     * * `'light'`
     * * `'dark'`
     */
    export type ColorVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

    /** Описание поля таблицы */
    export interface TableFieldDef {
        key: string;
        label: string;
    }

    /** Описание элемента выпадающего списка */
    export interface DropdownItemDef<T> {
        text: string;
        value: T;
        /** Полное название (подсказка), если text обрезан */
        title?: string;
    }

    /** Информация для рендеринга ячейки */
    export interface TableCellRenderData<T> {
        /** Данные строки */
        item: T;

        /** Значение для ячейки */
        value?: unknown;

        /** Описание поля */
        field?: TableFieldDef;
    }

    /**
     * Строка таблицы
     *
     * `T` - тип данных таблицы
     */
    export interface TableRow<T> {
        /**
         * ID
         *
         * Или ID сохраненной записи, или уникальная строка для только что созданной
         */
        id: string;

        /** Изменяемые данные */
        data: T;

        /** С этими данными сравнивается `data` для определения изменений */
        original: T | null;

        /** Признак "строка выделена" */
        selected: boolean;

        /** Признак "строка изменена" */
        changed: boolean;

        /** Признак "строка некорректна" */
        invalid: boolean;

        /** Варианты отображения строки в таблице */
        _rowVariant: ColorVariant | null;

        /** Отображать ли доп. панель для строки */
        _showDetails?: boolean;

        /** Ключи переводов ошибок для полей */
        errors: Record<string, any>;

        /**
         * Введенные пользователем значения
         *
         * _Используются, чтоб не терялись ошибки_
         */
        inputValues: Record<string, any>;
    }

    /** Строка таблицы в виде дерева */
    export interface TableTreeRow<T, TR extends TableTreeRow<T, TR>> extends TableRow<T> {
        /** Уровень строки */
        level: number;

        /** Родительская строка */
        parent: TR | null;

        /** Признак "нет детей" */
        leaf: boolean;

        /**
         * Дочерние строки
         *
         * _Пустой массив - нет детей_
         *
         * _`null` - дети еще не загружены_
         */
        children: TR[] | null;

        /** Признак "строка развернута" */
        expanded: boolean;
    }
}


/**
 * Типы для справочников
 */
export namespace Dict {
    /**
     * TODO old name - IDictBudgetLevel
     */
    export interface BudgetLevel {
        id: number | null;
        nameRu: string;
        nameKk: string;
        shortNameRu: string | null;
        shortNameKk: string | null;
        begDate: number | null;
        endDate: number | null;

        /**
         * Код
         */
        code: string;
    }

    // noinspection SpellCheckingInspection
    /**
     * TODO old name - IDictBudgetRegion
     */
    export interface BudgetRegions {
        id: number | null;
        nameRu: string | null;
        nameKk: string | null;
        sourceId: number | null;
        code: string | null;
        kaznDepName: string | null;
        kaznDepAddress: string | null;
        kaznDepRnn: string | null;
        kaznDepBin: string | null;
        begDate: number | null;
        endDate: number | null;
        obl: string | null;
        oblRu: string | null;
        oblKk: string | null;
    }


    export interface BudgetDataTypes {
        id: number;
        code: string;
        nameRu: string;
        nameKk: string | null;
        begDate: number | null;
        endDate: number | null;
    }

    /**
     * Типы для гражданских должностей
     */
    export namespace CivilPosition {
        /**
         * Сфера деятельности гражданской должности:
         * * `'ALL'` - Все сферы деятельности;
         * * `'EDUCATION'` - Образование (со статусом "педагог");
         * * `'EDUCATION_BEZ_STATUSA'` - Образование (без статуса "педагог");
         * * `'HEALTH'` - Здравоохранение;
         * * `'HEALTH_AND_EDUCATION'` - Здравоохранение; Образование;
         * * `'ALL_EXCEPT_HEALTH_AND_EDUCATION'` - Прочие сферы (кроме здравоохранения и образования);
         * * `'SPORT'` - Спорт.
         */
        export type ActivityField = 'ALL' | 'EDUCATION' | 'EDUCATION_BEZ_STATUSA' | 'HEALTH' | 'HEALTH_AND_EDUCATION' | 'ALL_EXCEPT_HEALTH_AND_EDUCATION' | 'SPORT';

        // noinspection GrazieInspection
        /**
         * Функциональный блок гражданской должности:
         * * `'A'` - Управленческий персонал
         * * `'B'` - Основной персонал
         * * `'C'` - Содействующий персонал (административный)
         * * `'D'` - Вспомогательный персонал
         */
        export type FunctionalBlock = 'A' | 'B' | 'C' | 'D';
    }

    /**
     * Гражданская должность TODO old name - IDictCivilPosition
     */
    export interface CivilPosition {
        /** ID */
        id: number | null;

        // noinspection GrazieInspection
        /**
         * Функциональный блок:
         * * "A" - Управленческий персонал
         * * "B" - Основной персонал
         * * "C" - Содействующий персонал (административный)
         * * "D" - Вспомогательный персонал
         */
        funcBlock: CivilPosition.FunctionalBlock;

        /**
         * Номер в ступени
         *
         * Заполняется, если в одной ступени несколько должностей
         */
        levelNumber: number | null;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Сфера деятельности:
         * * "ALL" - Все сферы
         * * "HEALTH_AND_EDUCATION" - Здравоохранение; Образование
         * * "ALL_EXCEPT_HEALTH_AND_EDUCATION" - Прочие сферы (кроме здравоохранения и образования)
         */
        activityField: CivilPosition.ActivityField | null;

        /**
         * Ступень
         */
        level: CivilPositionLevel | null;

        /** Уровень должности */
        posLevel: BudgetLevel | null;
    }

    export interface CivilPositionIncRate {
        /**
         * ID записи
         *
         * `PRIMARY KEY`
         */
        id: number | null;

        /**
         * Функциональный блок:
         * - "A" - управленческий персонал;
         * - "B" - основной персонал;
         * - "C" - содействующий персонал (административный);
         * - "D" - вспомогательный персонал.
         */
        funcBlock: CivilPosition.FunctionalBlock | null;

        /**
         * ID звена
         *
         * `REFERENCES public.dict_civil_position_level (id)`
         */
        level: number | null;

        /**
         * Сфера деятельности:
         * - "ALL" - все сферы;
         * - "EDUCATION" - образование;
         * - "HEALTH" - здравоохранение;
         * - "ALL_EXCEPT_HEALTH_AND_EDUCATION" - прочие сферы (кроме Здравоохранения; Образования).
         */
        activityField: CivilPosition.ActivityField | null;

        /**
         * Сфера деятельности - исключение:
         * - "ALL" - все сферы;
         * - "EDUCATION" - образование;
         * - "HEALTH" - здравоохранение;
         * - "ALL_EXCEPT_HEALTH_AND_EDUCATION" - прочие сферы (кроме Здравоохранения; Образования).
         */
        activityFieldExclusion: CivilPosition.ActivityField | null;

        /**
         * Период: от (включительно)
         */
        begDate: Date | null;

        /**
         * Период: до (не включительно)
         */
        endDate: Date | null;

        /**
         * Размер повышающего коэффициента к должностному окладу
         */
        rate: number;

        /**
         * Форма расчетов (в формате "F_XX_XXX", где "X" - цифра)
         */
        form: Report.FormKey | null;

        /**
         * Функциональная группа
         */
        funcGr: number | null;

        /**
         * Код нормативных часов организации образования (dict_st_edu_hours.code)
         */
        eduHoursCode: string | null;

        /**
         * Код типа огранизации образования
         */
        eduOrgTypeCode: string | null;

        /**
         * Код доп. атрибута
         */
        eadCode: string | null;

        /**
         * Базовый год
         */
        curYear: number | null;

        /**
         * Остаток от поправочного коэффициента.
         *
         * Для распределения по двум бюдж. программам.
         */
        rateRemainder: number | null;
    }

    /**
     * Типы для звена или ступени гражданской должности
     */
    export namespace CivilPositionLevel {
        /**
         * Тип звена или ступени гражданской должности:
         * * `'ECHELON'` - Звено (эшелон)
         * * `'LEVEL'` - Ступень (уровень)
         */
        export type LevelType = 'ECHELON' | 'LEVEL';
    }

    /**
     * Ступень гражданских должностей TODO old name - IDictCivilPositionLevel
     */
    export interface CivilPositionLevel {
        /**
         * ID
         */
        id: number | null;

        /**
         * Тип:
         * * "ECHELON" - звено (эшелон)
         * * "LEVEL" - ступень (уровень)
         */
        type: CivilPositionLevel.LevelType;

        /**
         * Код
         *
         * Одна цифра для звена ("ECHELON"); одна или две цифры, разделенные тире - для ступени ("LEVEL")
         */
        code: string;

        /**
         * Родительская запись
         */
        parent: CivilPositionLevel | null;
    }

    /**
     * Элемент ЕБК экономический, отсюда берутся специфики TODO old name - IDictEbkEk
     */
    export interface EbkEk {
        id: number | null;
        kat: number | null;
        cls: number | null;
        pcl: number | null;
        spf: number | null;
        nameRu: string | null;
        type: number | null;
        fullCode: string | null;
        nameKk: string | null;
        begDate: number | null;
        endDate: number | null;
        shortNameRu: string | null;
        shortNameKk: string | null;
    }

    /**
     * TODO old name - IDictEbkFunc
     */
    export interface EbkFunc {
        id: number | null;
        gr: number | null;
        pgr: number | null;
        abp: number | null;
        prg: number | null;
        ppr: number | null;
        nameRu: string | null;
        fullCode: string | null;
        type: number | null;
        nameKk: string | null;
        shortNameRu: string | null;
        shortNameKk: string | null;
        begDate: number | null;
        endDate: number | null;
        developType: number | null;
        isSequest: boolean | null;
        transfer: number | null;
        budgetSection: number | null;
        budgetLevelId: BudgetLevel | null;
    }

    /**
     * Должность организаций образования
     */
    export interface EduPosition {
        /**
         * ID
         */
        id: number | null;

        /**
         * Функциональный блок:
         *
         * * "A" - Управленческий персонал
         * * "B" - Основной персонал
         * * "C" - Содействующий персонал (административный)
         * * "D" - Вспомогательный персонал
         */
        funcBlock: string;

        /**
         * Номер в ступени
         *
         * Заполняется, если в одной ступени несколько должностей
         */
        levelNumber: number | null;

        /**
         * Название на английском
         */
        nameEn: string;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Уровень должности
         */
        posLevel: number | null;

        /**
         * Ступень
         */
        level: CivilPositionLevel | null;
    }

    /**
     * TODO old name - IDictGu
     */
    export interface Gu {
        id: number | null;
        code: string;
        sourceId: string;
        summaryFlag: string;
        nameRu: string;
        nameKk: string | null;
        guBin: string | null;
        guRnn: string | null;
        idRegion: string;
        idBudgetType: string | null;
        address: string | null;
        begDate: number | null;
        endDate: number | null;
        kato: string | null;
        budgetType: string | null;
        rucov: string | null;
        buhgal: string | null;
        abpOwner: string | null;
        idNsi: number | null;
        idIisk: number | null;
        budgetLevel: string | null;
        secret: string | null;
        committee: string | null;
        minlevel: string | null;
        idGbdul: string | null;
        codeKfs: string | null;
        codeOkpo: string | null;
        idEgz: string | null;
        source: string | null;
        nsithade8eyVersion: string | null;
        shortNameRu: string | null;
        shortNameKz: string | null;
        shortNameEn: string | null;
        isPublicity: string | null;
        budgetManag: string | null;
        orgAttribute: string | null;
        status: string | null;
        codeLoaded: string | null;
        lastUpdateDate: number | null;
        subjectKvaziSector: string | null;
        codeKopf: string | null;
        nameEn: string | null;
    }

    /**
     * КГКП TODO old name - IDictKgkp
     */
    export interface GuKgkp {
        id: number;
        nameRu: string;
        nameKk: string | null;
        codeGu: string | null;
        codeGuOwner: string | null;
        bin: string;
        begDate: number | null;
        endDate: number | null;
        userName: string | null;
        updateDate: number | null;
    }

    /**
     * Чин военнослужащего TODO old name - IDictMilitaryRank
     */
    export interface MilitaryRank {
        /**
         * ID
         */
        id: number | null;

        /**
         * Код
         */
        code: string;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Дата начала действия
         */
        begDate: number | null;

        /**
         * Дата окончания действия
         */
        endDate: number | null;

        /**
         * Надбавка
         */
        salaryIncrease: number;
    }

    /**
     * Звание/специальное звание военнослужащего TODO old name - IDictMilitaryTitle
     */
    export interface MilitaryTitle {
        /**
         * ID
         */
        id: number | null;

        /**
         * Код
         */
        code: string;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Дата начала действия
         */
        begDate: number | null;

        /**
         * Дата окончания действия
         */
        endDate: number | null;

        /**
         * Надбавка
         */
        salaryIncrease: number;
    }

    /**
     * TODO old name - IDictMvdPosition
     */
    export interface MvdPosition {
        id: number | null;
        category: string;
        numInCateg: number | null;
        nameKk: string;
        nameRu: string;
        kind: string;
        idTypeOrg: OrganizationTypeMvd | null;
        idBudLev: BudgetLevel | null;
        level: number | null
    }

    /**
     * Организация TODO old name - IDictOrg
     */
    export interface Org {
        /**
         * ID
         */
        id: number;

        /**
         * Код в формате "<тип организации>#<код организации>"
         *
         * Пример - "GU#4643180"
         *
         * Типы организаций:
         *
         * * "GU" - ГУ, поле [gu]
         * * "KGKP" - КГКП, поле [kgkp]
         */
        code: string;

        /**
         * ГУ
         */
        gu: Gu | null;

        /**
         * КГКП
         */
        kgkp: GuKgkp | null;
    }

    /**
     * Тип организации МВД TODO old name - IDictOrganizationTypeMvd
     */
    export interface OrganizationTypeMvd {
        /**
         * ID
         */
        id: number | null;

        /**
         * Наименование организации рус
         */
        nameRu: string;

        /**
         * Наименование организации каз
         */
        nameKk: string;

        shortNameRu: string | null;
        shortNameKk: string | null;

        /**
         * Дата начала деятельности
         */
        begDate: number;

        /**
         * Дата окончания деятельности
         */
        endDate: number;
    }

    /**
     * Типы для должностей госслужащих
     */
    export namespace Position {
        // noinspection GrazieInspection
        /**
         * Функциональный блок должности по НПА: TODO old name - TFunctionalBlock
         * * `'SCS'` - высший управленческий персонал
         * * `'A'` - основной персонал
         * * `'B'` - содействующий персонал
         * * `'C'` - вспомогательный персонал
         */
        export type FunctionalBlock = 'SCS' | 'A' | 'B' | 'C';

        /**
         * Уровень гос. управления должности по НПА TODO old name - TGovernmentLevel
         * * `'LOCAL'` - Местное
         * * `'TERRITORIAL'` - Территориальное
         */
        export type GovernmentLevel = 'LOCAL' | 'TERRITORIAL';

        /**
         * Вид государственной должности: TODO old name - TPositionKind
         * * `'ADMINISTRATIVE'` - Административная
         * * `'POLITICAL'` - Политическая
         * * `'DEPUTY'` - Депутат
         */
        export type Kind = 'ADMINISTRATIVE' | 'POLITICAL' | 'DEPUTY';
    }

    /**
     * Должность госслужащих
     */
    export interface Position {
        /**
         * ID
         */
        id: number | null;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Вид государственной должности:
         * * "ADMINISTRATIVE" - административная
         * * "POLITICAL" - политическая
         */
        kind: Position.Kind;

        // noinspection SpellCheckingInspection
        /**
         * Уровень госуправления:
         * * "LOCAL" - местное
         * * ""TERRITORIAL"" - территориальное
         */
        govLevel: Position.GovernmentLevel | null;

        // noinspection GrazieInspection
        /**
         * Функциональный блок:
         * * "SCS" - высший управленческий персонал
         * * "A" - основной персонал
         * * "B" - содействующий персонал
         * * "C" - вспомогательный персонал
         */
        funcBlock: Position.FunctionalBlock | null;

        /**
         * Уровень должности (Обычно 1-17)
         */
        posLevel: number;

        /**
         * № п/п в категории
         */
        categoryNumber: string | null;

        /**
         * Регион
         */
        region: BudgetRegions | null;

        /**
         * Уровень категории должности
         */
        categoryLevel: BudgetLevel | null;

        /**
         * Категория должности
         */
        category: PositionCategory | null;
    }

    /**
     * Должность госслужащих (ID вместо объектов)
     */
    export interface Position_Simplified {
        /**
         * ID
         */
        id: number | null;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Вид государственной должности:
         * * "ADMINISTRATIVE" - административная
         * * "POLITICAL" - политическая
         */
        kind: Position.Kind;

        // noinspection SpellCheckingInspection
        /**
         * Уровень госуправления:
         * * "LOCAL" - местное
         * * ""TERRITORIAL"" - территориальное
         */
        govLevel: Position.GovernmentLevel | null;

        // noinspection GrazieInspection
        /**
         * Функциональный блок:
         * * "SCS" - высший управленческий персонал
         * * "A" - основной персонал
         * * "B" - содействующий персонал
         * * "C" - вспомогательный персонал
         */
        funcBlock: Position.FunctionalBlock | null;

        /**
         * Уровень должности (Обычно 1-17)
         */
        posLevel: number;

        /**
         * Регион
         */
        region: number | null;

        /**
         * Уровень категории должности
         */
        categoryLevel: number | null;

        /**
         * Категория должности
         */
        category: number | null;

        /**
         * № п/п в категории
         */
        categoryNumber: string | null;
    }

    /**
     * Типы для категорий должностей
     */
    export namespace PositionCategory {
        /**
         * Тип категории должности по НПА: TODO old name - TDictPositionCategoryType
         * * `CORPS` - корпус
         * * `GROUP` - группа категорий
         * * `CATEGORY` - категория
         */
        export type CategoryType = 'CORPS' | 'GROUP' | 'CATEGORY';
    }

    /**
     * Категория должностей TODO old name - IDictPositionCategory
     */
    export interface PositionCategory {
        /**
         * ID
         */
        id: number | null;

        /**
         * Тип:
         * * "CORPS" - корпус
         * * "GROUP" - группа категорий
         * * "CATEGORY" - категория
         */
        type: PositionCategory.CategoryType;

        /**
         * Код
         */
        code: string;


        /**
         * Родительская запись
         */
        parent: PositionCategory | null;
    }

    /**
     * Должностной оклад для госслужащих АГС МВД
     */
    export interface PositionMvdSalary_Simplified {
        /**
         * ID
         *
         * `PRIMARY KEY`
         */
        id: number | null;

        /**
         * Уровень должности (Обычно 1-17)
         */
        posLevel: number;

        /**
         * Стаж - "от" (минимальный)
         */
        experienceMin: number;

        /**
         * Стаж - "до" (максимальный)
         */
        experienceMax: number;

        /**
         * Оклад
         */
        salary: number;

        /**
         * Вид должности:
         * * "ADMINISTRATIVE" - административная;
         * * "POLITICAL" - политическая;
         * * "DEPUTY" - депутат.
         */
        positionKind: string;

        /**
         * Дата начала действия
         */
        begDate: Date | null;

        /**
         * Дата окончания действия
         */
        endDate: Date | null;

        /**
         * Базовый год
         */
        curYear: number | null;
    }

    /**
     * Должностные оклады
     */
    export interface PositionSalary {
        /**
         * ID
         *
         * `PRIMARY KEY`
         */
        id: number | null;

        /**
         * Уровень должности (Обычно 1-17)
         */
        posLevel: number;

        /**
         * Стаж - "от" (минимальный)
         */
        experienceMin: number;

        /**
         * Стаж - "до" (максимальный)
         */
        experienceMax: number;

        /**
         * Оклад
         */
        salary: number;

        /**
         * Вид должности:
         * * "ADMINISTRATIVE" - Административная
         * * "POLITICAL" - Политическая
         * * "DEPUTY" - Депутат
         */
        positionKind: string;

        /**
         * Дата начала действия
         */
        begDate: Date | null;

        /**
         * Дата окончания действия
         */
        endDate: Date | null;

        /**
         * Базовый год
         */
        curYear: number | null;
    }

    /**
     * Вариант должности госслужащих
     */
    export interface PositionVariants {
        /**
         * ID
         */
        id: number | null;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Вид государственной должности:
         * * "ADMINISTRATIVE" - административная
         * * "POLITICAL" - политическая
         */
        kind: Position.Kind;

        // noinspection SpellCheckingInspection
        /**
         * Уровень госуправления:
         * * "LOCAL" - местное
         * * ""TERRITORIAL"" - территориальное
         */
        govLevel: Position.GovernmentLevel | null;

        // noinspection GrazieInspection
        /**
         * Функциональный блок:
         * * "SCS" - высший управленческий персонал
         * * "A" - основной персонал
         * * "B" - содействующий персонал
         * * "C" - вспомогательный персонал
         */
        funcBlock: Position.FunctionalBlock | null;

        /**
         * Уровень должности (Обычно 1-17)
         */
        posLevel: number;

        /**
         * Регион
         */
        region: BudgetRegions | null;

        /**
         * Уровень категории должности
         */
        categoryLevel: BudgetLevel | null;

        /**
         * Категория должности
         */
        category: PositionCategory | null;

        /**
         * № п/п в категории
         */
        categoryNumber: string | null;

        /**
         * Основная запись (оригинал должности)
         */
        main: Position | null;

        /**
         * Дата начала действия (включительно)
         */
        begDate: Date | null;

        /**
         * Дата окончания действия (не включительно)
         */
        endDate: Date | null;

        /**
         * Базовый год отчета, начальное значение, включительно
         */
        curYearBeg: number | null;

        /**
         * Базовый год отчета, конечное значение, не включительно
         */
        curYearEnd: number | null;

        /**
         * Год упразднения должности (начиная с начала этого года должность считается упраздненной)
         */
        closingYear: number | null;
    }

    /**
     * Вариант должности госслужащих
     */
    export interface PositionVariants_Simplified {
        /**
         * ID
         */
        id: number | null;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Вид государственной должности:
         * * "ADMINISTRATIVE" - административная
         * * "POLITICAL" - политическая
         */
        kind: Position.Kind;

        // noinspection SpellCheckingInspection
        /**
         * Уровень госуправления:
         * * "LOCAL" - местное
         * * ""TERRITORIAL"" - территориальное
         */
        govLevel: Position.GovernmentLevel | null;

        // noinspection GrazieInspection
        /**
         * Функциональный блок:
         * * "SCS" - высший управленческий персонал
         * * "A" - основной персонал
         * * "B" - содействующий персонал
         * * "C" - вспомогательный персонал
         */
        funcBlock: Position.FunctionalBlock | null;

        /**
         * Уровень должности (Обычно 1-17)
         */
        posLevel: number;

        /**
         * Регион
         */
        region: number | null;

        /**
         * Уровень категории должности
         */
        categoryLevel: number | null;

        /**
         * Категория должности
         */
        category: number | null;

        /**
         * № п/п в категории
         */
        categoryNumber: string | null;

        /**
         * Основная запись (оригинал должности)
         */
        main: number;

        /**
         * Дата начала действия (включительно)
         */
        begDate: Date | null;

        /**
         * Дата окончания действия (не включительно)
         */
        endDate: Date | null;

        /**
         * Базовый год отчета, начальное значение, включительно
         */
        curYearBeg: number | null;

        /**
         * Базовый год отчета, конечное значение, не включительно
         */
        curYearEnd: number | null;

        /**
         * Год упразднения должности (начиная с начала этого года должность считается упраздненной)
         */
        closingYear: number | null;
    }

    /**
     * Типы для дополнительных атрибутов сотрудников TODO old name - IDictStEad
     */
    export namespace StEad {
        /**
         * Вид доп. атрибута:
         * * "ADD_FLAG" - Дополнительный признак (флаг)
         * * "ADD_PAYMENT" - Доплата
         * * "ALLOWANCE" - Надбавка
         * * "BENEFIT" - Пособие
         * * "COMPENSATION" - Компенсация
         * * "MISC" - Разное
         * * "SEASONAL_EMPLOYEE" - Сезонный рабочий
         */
        export type AddAttrKind = 'ADD_FLAG' | 'ADD_PAYMENT' | 'ALLOWANCE' | 'BENEFIT' | 'COMPENSATION' | 'MISC' | 'SEASONAL_EMPLOYEE';

        /**
         * Тип дополнительного атрибута:
         *
         * * `'BOOL'` - Логическое значение
         * * `'DATE'` - Дата
         * * `'MILITARY_RANK'` - Чин военнослужащего
         * * `'MILITARY_TITLE'` - Звание военнослужащего
         * * `'NORMATIVE'` - Коэффициент к значению из dict_normative_inds
         * * `'NUMBER'` - Просто число
         * * `'SALARY_RATE'` - Коэффициент к расчетному окладу
         * * `'TEXT'` - Текст
         * * `'HOURS'` - Расчет от часовой ставки
         */
        export type AddAttrType = 'BOOL' | 'DATE' | 'MILITARY_RANK' | 'MILITARY_TITLE' | 'NORMATIVE' | 'NUMBER' | 'SALARY_RATE' | 'TEXT' | 'HOURS';
    }

    /**
     * Дополнительный атрибут сотрудников TODO old name - IDictStEad
     */
    export interface StEad {
        /**
         * ID
         */
        id: number | null;

        /**
         * Код
         */
        code: string;

        /**
         * Тип данных
         *
         * Возможные значения:
         * * "BOOL" - Логическое значение
         * * "TEXT" - Текст
         * * "NUMBER" - Просто число
         * * "SALARY_RATE" - Коэффициент к расчетному окладу
         * * "NORMATIVE" - Коэффициент к значению из dict_normative_inds
         * * "DATE" - Дата
         * * "MILITARY_RANK" - Чин военнослужащего
         * * "MILITARY_TITLE" - Звание военнослужащего
         */
        attrType: StEad.AddAttrType;

        /**
         * Вид дополнительного атрибута
         *
         * Возможные значения:
         * * "ADD_PAYMENT" - Доплата
         * * "ALLOWANCE" - Надбавка
         * * "BENEFIT" - Пособие
         * * "COMPENSATION" - Компенсация
         * * "ADD_FLAG" - Дополнительный признак (флаг)
         * * "MISC" - Разное
         */
        kind: StEad.AddAttrKind;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Подзаголовок колонки на казахском (обычно - единица измерения)
         */
        subtitleKk: string | null;

        /**
         * Подзаголовок колонки на русском (обычно - единица измерения)
         */
        subtitleRu: string | null;

        /**
         * Код нормативного показателя, если используется
         *
         * Используются коды из таблицы dict_normative_inds
         *
         * Должно заполняться, если [attrType] равен "NORMATIVE"
         */
        dictNormIndCode: string | null;

        /**
         * "Предварительный" множитель значения, множитель введенного пользователем значения
         *
         * Если заполнено, то значение доп. атрибута перед какими-либо расчетами должно умножаться на это значение
         */
        preMultiplier: number | null;

        /**
         * Шаблон заголовка колонки для определенного значения
         *
         * Используется, только если есть записи в stafftab_ead_acv, которые ссылаются на текущую запись
         */
        valueColumnTitleTemplate: string | null;

        /** Множитель значения, для использования с [valueColumnTitleTemplate] */
        valueColumnTitleMultiplier: number | null;

        /**
         * Признак "доступен выбор бюджетной программы"
         */
        allowBudgetProgSelect: boolean;

        /**
         * Признак "доступен расчет на основе фактической нагрузки" (используется в организациях образования)
         */
        allowFactWorkloadCalc: boolean;

        /**
         * Признак "доступены настройки сроков действия"
         */
        allowPeriod: boolean;

        /**
         * Ключи форм расчетов
         */
        formKeys: string | null;
    }

    export namespace StEdu {
        /**
         * Код организации:
         *  "`01`" - Дошкольные организации
         *  "`02`" - Организации среднего образования (начального, основного среднего, общего среднего)
         *  "`03`" - Организации технического и профессионального образования (ТиПО)
         *  "`04`" - Специализированные организации образования
         *  "`05`" - Специальные организации образования
         *  "`06`" - Организации образования для детей-сирот и детей, оставшихся без попечения родителей
         *  "`07`" - Организации дополнительного образования для детей
         */
        export type OrgTypeCode = '01' | '02' | '03' | '04' | '05' | '06' | '07';
    }

    /**
     * Элемент справочника нормативных часов в организациях образования
     */
    export interface StEduHours {
        /**
         * ID
         */
        id: number | null;

        /**
         * Название на английском
         */
        nameEn: string;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Дата начала действия (включительно)
         */
        begDate: number | null;

        /**
         * Дата окончания действия (включительно)
         */
        endDate: number | null;

        /**
         * Значение (количество часов)
         */
        value: number | null;

        /**
         * Единица измерения на английском (напр. "в неделю")
         */
        unitEn: string;

        /**
         * Единица измерения на казахском (напр. "в неделю")
         */
        unitKk: string;

        /**
         * Единица измерения на русском (напр. "в неделю")
         */
        unitRu: string;

        /**
         * Код
         */
        code: string;

        /**
         * Порядковый номер строки
         */
        orderNumber: number | null;

        /**
         * Тип организации
         */
        orgType: StEduOrgType | null;
    }

    /**
     * Тип организаций образования
     */
    export interface StEduOrgType {
        /**
         * ID
         */
        id: number | null;

        /**
         * Код
         */
        code: string;

        /**
         * Название на английском
         */
        nameEn: string;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Дата начала действия (включительно)
         */
        begDate: number | null;

        /**
         * Дата окончания действия (включительно)
         */
        endDate: number | null;
    }

    /**
     * Справочник уровней образования
     */
    export interface DictEducationLevel {

        /**
         * ID
         */
         id: number | null,

        /**
         * ID родительского элемента
         */
         parentId: number | null,

        /**
         * Код
         */
         code: string,

        /**
         * Наименование на русском языке
         */
         nameRu: string,

        /**
         * Наименование на казахском языке
         */
         nameKk: string,

        /**
         * Краткое наименование на русском языке
         */
         shortNameRu: string | null,

        /**
         *  Краткое наименование на казахском языке
         */
         shortNameKk: string | null,

        /**
         *  Дата начала действия элемента
         */
         begDate: number | null,

        /**
         *  Дата окончания действия элемента
         */
         endDate: number | null

    }

    /**
     * Справочник предметов образования
     */
    export interface StEduSubject {

        /**
         * ID
         */
        id: number | null,

        /**
         * ID родительского элемента
         */
        parentId: number | null,

        /**
         * Код
         */
        code: string,

        /**
         * Наименование на русском языке
         */
        nameRu: string,

        /**
         * Наименование на казахском язык
         */
        nameKk: string,

        /**
         * Краткое наименование на русском языке
         */
        shortNameRu: string | null,

        /**
         *  Краткое наименование на казахском языке
         */
        shortNameKk: string | null,

        /**
         *  Дата начала действия элемента
         */
        begDate: number | null,

        /**
         *  Дата окончания действия элемента
         */
        endDate: number | null

        /**
         * Код региона
         */
        regionCode: string | null,

        /**
         * Тип предмета
         */
        kind: string | null,

        /**
         * Код организации
         */
        orgTypeCode: string[] | null,

        /**
         * Тип предмета наименование рус
         */
        kindNameRu: string | null,

        /**
         * Тип предмета наименование каз
         */
        kindNameKk: string | null,

    }

    /**
     * Колонка отчетов штатного расписания
     */
    export interface StRepFormCol {
        /**
         * ID
         */
        id: number | null;

        /**
         * ID группы колонок
         */
        colGroup: number;

        /**
         * Порядковый номер
         *
         * _для сортировки колонок внутри группы_
         */
        orderNumber: number;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Название единицы измерения на казахском
         */
        unitNameKk: string | null;

        /**
         * Название единицы измерения на русском
         */
        unitNameRu: string | null;

        /**
         * Код вида агрегации.
         *
         * Применяется только для чисел.
         *
         * Возможные значения:
         * * "SUM" - сумма;
         * * "AVG" - среднее арифметическое.
         */
        aggregation: string | null;

        /**
         * Ширина колонки в пикселях
         */
        width: number;

        /**
         * Код источника данных
         */
        dataSource: string;

        /**
         * Тип колонки
         *
         * Пригодится, если колонка используется в других колонках
         */
        colType: string | null;

        /**
         * Признак "редактируется при распределении по подпрограммам"
         */
        subprogDistEditable: boolean;

        /**
         * Признак "отображать только в расширенном отчете"
         */
        detailedReportOnly: boolean;

        /**
         * Признак "удалять колонку, если в ней нет данных"
         */
        removeIfNoData: boolean;

        /**
         * Количество цифр в дробной части.
         *
         * NULL означает "без ограничений" - сколько цифр есть в дробной части, столько и будет отображаться.
         *
         * Значения меньше нуля принимаются равными нулю.
         *
         * Используется при форматировании значений.
         */
        fractionalDigitCount: number | null;

        /**
         * Признак "Колонка для отправки в свод"
         */
        forTotal: boolean;

        /**
         * Признак "Колонка для отладки"
         */
        debug: boolean;

        /**
         * Список типов отчетов, в которых будет использоваться колонка.
         *
         * Возможные значения (типы отчетов):
         * * 'COMMON' - обычный отчет;
         * * 'DETAILED' - расширенный отчет.
         */
        reportTypes: Array<string | null>;

        /**
         * Код колонки
         */
        code: string | null;
    }

    /**
     * Группа колонок отчетов штатного расписания
     */
    export interface StRepFormColGroup {
        /**
         * ID
         */
        id: number | null;

        /**
         * ID родительской группы колонок
         */
        parent: number | null;

        /**
         * Код формы в формате "XX-XXX", где "X" - цифра
         */
        form: string;

        /**
         * Название на казахском
         */
        nameKk: string;

        /**
         * Название на русском
         */
        nameRu: string;

        /**
         * Порядковый номер - для сортировки групп внутри одного родителя или групп верхнего уровня
         */
        orderNumber: number;

        /**
         * Ячейка группы может быть скрыта при разных условиях.
         *
         * _"null" считается равным "false"_
         */
        hiddableCell: boolean | null;

        /**
         * Список типов отчетов, в которых будет использоваться колонка.
         *
         * Возможные значения (типы отчетов):
         * - 'COMMON' - обычный отчет;
         * - 'DETAILED' - расширенный отчет.
         * - 'DEBUG' - Отладка.
         */
        reportTypes: Array<string | null>;
    }

    /**
     * Поправочный коэффициент рабочих должностей
     */
    export interface WorkPositionIncRate {
        /**
         * ID записи
         *
         * `PRIMARY KEY`
         */
        id: number | null;

        /**
         * Размер поправочного коэффициента к должностному окладу
         */
        rate: number;

        /**
         * Дата начала действия (включительно)
         */
        begDate: Date | null;

        /**
         * Дата окончания действия (не включительно)
         */
        endDate: Date | null;

        curYear: number | null;

        /**
         * Остаток от поправочного коэффициента.
         *
         * *Для распределения по двум бюдж. программам*
         */
        rateRemainder: number | null;
    }

    /**
     * Квалификационный разряд для рабочих должностей
     */
    export interface WorkPositionRank {
        /**
         * ID
         */
        id: number | null;

        /**
         * Код
         */
        code: string;

        /**
         * Квалификационный разряд (число от 1 до 8)
         */
        rank: number;

        /**
         * Коэффициент к БДО
         */
        rate: number;

        /**
         * Дата начала действия
         */
        begDate: Date | null;

        /**
         * Дата окончания действия
         */
        endDate: Date | null;

        curYear: number | null;
        rateRemainder: number | null;
    }
}


/** Отдел ГУ TODO old name - IDictGuDepartment*/
export interface Department {
    /** ID */
    id: number | null;

    /** Название на казахском */
    nameKk: string;

    /** Название на русском */
    nameRu: string;

    /** Порядковый номер */
    serialNumber: number | null;

    /** Признак "нет детей" */
    leaf: boolean;

    /** Дочерние подразделения */
    children: Array<Department> | null;
}


/** Типы для доп. атрибутов */
export namespace Ead {
    /** Настройка доп. атрибута TODO old name - IStafftabEadC */
    export interface EadC {
        /** ID */
        id: number | null;

        /** Логическое значение по умолчанию */
        valueBool: boolean | null;

        /** Текстовое значение по умолчанию */
        valueText: string | null;

        /** Числовое значение по умолчанию */
        valueNumber: number | null;

        /** Коэффициент к расчетному окладу по умолчанию */
        valueSalaryRate: number | null;

        /** Коэффициент к нормативному показателю по умолчанию */
        valueNormRate: number | null;

        /** Значение типа "дата" по умолчанию */
        valueDate: number | null;

        /** Дополнительный атрибут */
        ead: Dict.StEad | null;

        /**
         * Используется с доп. атрибутами attrType равен "NORMATIVE"
         *
         * Признак - применения ставки в расчетах доплат/надбавок (allowRate = true - ставка используется)
         */
        allowRate: boolean;

        /** Версия ШР */
        version: Version | null;

        /**
         * Код бюджетной программы
         *
         * Не учитывается, если в связанной записи "dict_st_ead" значение "allow_budget_prog_select" не равно "true"
         */
        budgetProgram: number | null;

        /**
         * Подсказки о типе расчёта:
         *
         * Особенности:
         * - `"TIME_RATE"` — учитывать ставку;
         * - `"FACT_WORKLOAD"` — учитывать фактическую нагрузку;
         * - Эти подсказки настраиваются только в общих настройках, но при установке значений
         *   автоматически копируются в индивидуальные настройки метод на фронте - [syncCalcHintCode].
         */
        calcHint: Array<string> | null;

        /**
         * Начала действия
         */
        startPeriod: number | null;

        /**
         * Окончание действия
         */
        endPeriod: number | null;

        /**
         * Есть подтверждающий документ
         */
        hasDocument: boolean;
    }

    /** Доп. атрибут TODO old name - IStafftabEadD */
    export interface EadD {
        /** ID */
        id: number | null;

        /** Сотрудник */
        emp: Employee | null;

        /** Настройка */
        conf: EadC | null;

        /** Логическое значение */
        valueBool: boolean | null;

        /** Текст */
        valueText: string | null;

        /** Просто число */
        valueNumber: number | null;

        /** Коэффициент к расчетному окладу */
        valueSalaryRate: number | null;

        /** Коэффициент к значению из dict_normative_inds */
        valueNormRate: number | null;

        /** Дата */
        valueDate: number | null;

        /** Чин военнослужащего */
        valueMilitaryRank: Dict.MilitaryRank | null;

        /** Звание военнослужащего */
        valueMilitaryTitle: Dict.MilitaryTitle | null;

        /**
         * Подсказки о типе расчёта:
         *
         * Особенности:
         * - `"TIME_RATE"` — учитывать ставку;
         * - `"FACT_WORKLOAD"` — учитывать фактическую нагрузку;
         * - Эти подсказки настраиваются только в общих настройках, но при установке значений
         *   автоматически копируются в индивидуальные настройки метод на фронте - [syncCalcHintCode].
         */
        calcHint: Array<string> | null;

        /**
         * Фактическая нагрузка в часах для сотрудников организации образования  БДО/МРП
         */
        factHours: number | null

        /**
         * Начала действия
         */
        startPeriod: number | null;

        /**
         * Окончание действия
         */
        endPeriod: number | null;

        /**
         * Есть подтверждающий документ
         */
        hasDocument: boolean;
    }

    /** Списки выподающих значений для дополнительных атрибутов*/
    export interface stEadDropdownValues {
        /** ID */
        id: number;

        /** Дополнительный атрибут */
        ead: Dict.StEad;

        /** Название на русском */
        nameRu: string;

        /** Название на казахском */
        nameKk: string;

        /** Название на английском */
        nameEn: string;

        /** Просто число */
        valueNumber: number | null;

        /** Логическое значение */
        valueBool: boolean | null;

        /** Дата */
        valueDate: number | null;

        /** Код региона */
        codeRegion: string | null;

        /** Вариант сортировки */
        sortOrder: string;
    }

    export interface stEadEduDropdownValues {
        /** ID */
        id: number;

        /** Дополнительный атрибут */
        eadEdu: Dict.StEduHours;

        /** Название на русском */
        nameRu: string;

        /** Название на казахском */
        nameKk: string;

        /** Название на английском */
        nameEn: string;

        /** Просто число */
        valueNumber: number | null;

        /** Логическое значение */
        valueBool: boolean | null;

        /** Дата */
        valueDate: number | null;

        /** Код региона */
        codeRegion: string | null;

        /** Вариант сортировки */
        sortOrder: string;
    }
}


/**
 * Типы для организаций образования
 */
export namespace Edu {
    /**
     * Настройка фактической нагрузки сотрудников организации образования
     */
    export interface WlC {
        /**
         * ID
         */
        id: number | null;


        /**
         * Элемент справочника нормативных часов
         */
        hours: Dict.StEduHours | null;

        /**
         * Версия штатного расписания
         */
        version: Version | null;
    }

    /**
     * Фактическая нагрузка сотрудников организации образования
     */
    export interface WlD {
        /**
         * ID
         */
        id: number | null;

        /**
         * Сотрудник
         */
        emp: Employee | null

        /**
         * Настройка фактической нагрузки
         */
        conf: WlC | null;

        /**
         * Значение - количество часов
         */
        value: number | null;

        /**
         * Коэффициент к БДО
         */
        bdoCoefficient: number | null;
    }
}


/** interface файлового хранилища для модуля штатного расписания TODO old name - IStaffTabFileStorage */
export interface FileStorage {
    /*** ID */
    id: number | null;

    /** Регион */
    region: string;

    /** Организация */
    org: string;

    /** АБП */
    abp: number;

    /** Бюджетная программа */
    prg: number;

    /** Имя файла */
    fileName: string;

    /** Версия бюджета */
    variantUuid: string;

    /** Первый год планового периода */
    curYear: number;

    /** Дата актуальности */
    actualDate: Date | null;

    /** Дата загрузки файла */
    uploadDate: Date | null;

    /** ID пользователя в keycloak */
    keycloakUserId: string;

    /** Размер файла */
    fileSize: number;

    /** Размер файла */
    multipartFile: File | null;
}


/**
 * Локальное хранилище штатного расписания
 */
export interface ModuleStore {
    /**
     * Признак "Хранилище инициализировано"
     */
    readonly initialized: boolean;

    /**
     * АБП
     */
    abp: Dict.EbkFunc | null;

    /**
     * Организация
     */
    org: Org | null;

    /**
     * Версия ШР
     */
    version: Version | null;

    /**
     * Год отчета
     */
    reportYear: number;

    /**
     * Дата отчета
     */
    readonly reportDate: Date;

    /**
     * Версия бюджета
     */
    budgetVariant: BudgetVariants | null;

    /**
     * Бюджетная программа
     */
    budgetProgram: Dict.EbkFunc | null;

    /**
     * Бюджетная подпрограмма
     */
    budgetSubprogram: Dict.EbkFunc | null;

    /**
     * Форма
     */
    form: Report.FormKey | null;

    /**
     * Специфика
     */
    specificity: Dict.EbkEk | null;

    /**
     * Выбранный департамент
     */
    gaDepartmentList: Department[]

    /**
     * Дочерние департаменты, связанные с департаментом из gaDepartmentList
     */
    subDepartments: Department[]

    /**
     * Режим отображения сотрудников:
     *
     *  "STAFF_TAB" - отображение сотрудников с "обычными" должностями (не должностями в образовании);
     * "TARIFFICATION" - отображение сотрудников с должностями в образовании.
     */
    employeeMode: employeePositionMode | null

    /**
     * Ключ шаблона отчета
     */
    templateKey: TemplateKey | null;

    /**
     * Шаблон отчетов
     */
    conditionExp: BoolEx.Expression<boolean> | null;

    /**
     * Множественный выбор Бп
     */
    multiSelectedBudgetProgram: Dict.EbkFunc [];

    /**
     * Множественный выбор специфики
     */
    selectedSpecificOptions: Dict.EbkEk [];

    /**
     * Множественный выбор форм
     */
    selectedOptionsForms: string [];
}

export interface ModuleAccess {
    /*** Признак "Хранилище инициализировано" */
    readonly initialized: boolean;

    /*** Код модуля штатного расписания */
    readonly moduleCode: string | null

    /*** Данные уровня доступа пользователя */
    readonly moduleLink: Readonly<UserModulesLink> | null;

    /**
     * Флаг, определяющий, может ли пользователь редактировать данные.
     *
     * Уровни доступа:
     * - `1 = false` (ограниченный доступ) → пользователь **не может** создавать или редактировать данные, UI-элементы скрываются или отключаются.
     * - `2 = true` (полный доступ) → пользователь **может** создавать и редактировать данные, UI-элементы активны.
     */
    readonly isEditable: boolean

    /**
     * Признак "пользователь является администратором модуля «Штатное расписание»"
     */
    readonly isAdmin: boolean;

    /*** Список доступных пользователю организации  */
    readonly accessibleGuSet: ReadonlySet<string>;

    /*** Список доступных пользователю КГКП  */
    readonly accessibleBinKgkpSet: ReadonlySet<string>;

    /*** Признак "Руководитель АБП" */
    readonly isAbpLead: boolean;

    /*** Признак "Руководитель УО" */
    readonly isUoLead: boolean;

    /*** Признак "Консультант" */
    readonly isConsultant: boolean;

    /*** Признак "Техподдержка" */
    readonly isTechSupport: boolean;

    /*** Признак "Отдел образования" */
    readonly isEducation: boolean;

    /**
     * Признак "Можно видеть вкладку Сводные отчёты".
     */
    readonly canViewSummaryReports: boolean;

    /** Список мест работы пользователя */
    readonly workplaceInfoList: Array<User.WorkplaceInfo>;
}

export interface UserModulesLink {
    id: number,
    userId: string,
    modules: string,
    accessLevel: number
    operations: string[]
}

/**
 * Пространство имен для типов, связанных с пользователями
 */
export namespace User {
    /**
     * Место работы (скорее всего) пользователя
     */
    export interface WorkPlaceLink {
        id: number | null;
        userId: string;
        workplace: string;
        lead: boolean | null;
    }

    /**
     * Информация о месте работы
     */
    export interface WorkplaceInfo {
        /**
         * Место работы (ссылка)
         */
        link: WorkPlaceLink,

        /**
         * ГУ
         */
        gu: Dict.Gu,
    }
}


/** Типы для организаций */
export namespace Org {
    /**
     * Тип организации: TODO old name - TOrgType
     *
     * * `'GU'` - ГУ
     * * `'KGKP'` - КГКП
     */
    export type OrgType = 'GU' | 'KGKP';


    /** "Обертка" организации TODO old name - IStaffTabOrgBase */
    export interface Base {
        /** Тип */
        type: OrgType;

        /** Организация */
        org: Dict.Org;

        /**
         * Код организации, варианты:
         *
         * * ГУ - код
         * * КГКП - БИН
         */
        code: string;

        /** Название на казахском */
        nameKk: string;

        /** Название на русском */
        nameRu: string;
    }

    /** "Обертка" ГУ */
    export interface Gu extends Base {
        /** Тип */
        type: 'GU';

        /** ГУ */
        gu: Dict.Gu;
    }

    /** "Обертка" КГКП */
    export interface Kgkp extends Base {
        /** Тип */
        type: 'KGKP';

        /** КГКП */
        kgkp: Dict.GuKgkp;

        /** ГУ, связанное с КГКП */
        gu: Dict.Gu | null
    }


    /**
     * Настройки организации
     */
    export interface Settings {
        /**
         * Зарплатная форма
         */
        form: Report.FormKey | null;

        /**
         * Код бюджетной программы
         */
        budgetProgram: number | null;

        /**
         * Тип организации
         */
        orgType: string | null;
    }
}

export type Org = Org.Gu | Org.Kgkp;

/**
 * Вариант отображения сотрудников для организаций образования:
 *
 * * "STAFF_TAB" - сотрудники с "обычными" должностями (не должности образования);
 * * "TARIFFICATION" - сотрудники с должностями образования.
 */
export type employeePositionMode = 'STAFF_TAB' | 'TARIFFICATION';

/**
 * Типы для должностей
 */
export namespace Position {
    /**
     * Фильтры должностей:
     *
     * * "NO_EDU" - не отображать должности образования;
     * * "ONLY_EDU" - отображать только должности образования.
     */
    export type Filter = 'NO_EDU' | 'ONLY_EDU';
}

/** Должность в организации, данные из БД TODO old name - IGuDepartmentPosition */
export interface Position {
    /** ID */
    id: number | null;

    /** Название на казахском */
    nameKk: string;

    /** Название на русском */
    nameRu: string;

    /** Функциональный блок */
    funcBlock: Dict.Position.FunctionalBlock | null;

    /** Уровень должности */
    posLevel: number | null;

    /** Должность по НПА */
    legalActPosition: Dict.Position | null;

    /** Гражданская должность */
    civilPosition: Dict.CivilPosition | null;

    /** Квалификационный разряд рабочей должности (число от 1 до 8) */
    workPositionRank: number | null;

    /** Мвд должность */
    mvdPosition: Dict.MvdPosition | null;

    /** Должность по НПА для сотрудников Мвд */
    legalActMvdPosition: Dict.Position | null;

    /** Должность организации образования */
    eduPosition: Dict.EduPosition | null;

    /** Версия ШР */
    version: Version | null;

    /** Вариант должности по НПА */
    legalActPositionVariant: Dict.PositionVariants | null;
}


/** Типы для отчетов */
export namespace Report {
    /** Данные (строки) отчета TODO old name - IStafftabReportData */
    export interface ReportData {
        /** Имена полей дат */
        dateFields: string[];

        /** Строки отчета */
        rows: Array<Record<string, unknown>>;
    }

    /** Информация о поле отчета TODO old name - IStafftabReportFieldInfo */
    export interface FieldInfo {
        title: string;
        subtitle?: string;
        isDateField?: boolean;
    }

    /** Ключ формы отчета TODO old name - TReportFormKey */
    export type FormKey =
        'F_01_111' | 'F_01_112' | 'F_01_113' | 'F_01_116' | 'F_01_121' | 'F_01_122' | 'F_01_124' | 'F_01_131' | 'F_01_132' | 'F_01_135'
        | 'F_02_111' | 'F_02_114' | 'F_02_131'
        | 'F_03_135'
        | 'F_04_111'
        | 'F_05_111'
        | 'F_06_111'
        | 'F_07_111'
        | 'F_08_111'
        | 'F_09_111'
        | 'F_10_111'
        | 'F_11_111'
        | 'F_13_111'
    ;

    /** Типы для отчетов 1 версии */
    export namespace Version1 {
        /** Колонка отчета TODO old name - IStafftabRepCol */
        export interface Col {
            /** ID записи */
            id: number | null;

            /** Отчет */
            report: Report | null;

            /** Порядковый номер колонки в отчете */
            orderNumber: number;

            /** Заголовок на казахском */
            titleKk: string;

            /** Заголовок на русском */
            titleRu: string;

            /** Подзаголовок на казахском */
            subtitleKk: string | null;

            /** Подзаголовок на русском */
            subtitleRu: string | null;

            /** Ключ поля (для связи с [StafftabRepValEntity.field]) */
            field: string;

            /** Если равно "true", то в колонке хранятся значения дат */
            dateField: boolean;
        }
    }

    /** Типы для отчетов версии 2 */
    export namespace Version2 {
        /**
         * Специальный тип для колонки листа отчета (отчеты версии 2): TODO old name - TStafftabRep2ColSpecType
         *
         * * "MIN_SUM_FOR_SUBPROGRAM_DIV" - Минимальная сумма для деления по подпрограммам
         * * "MAX_SUM_FOR_SUBPROGRAM_DIV" - Максимальная сумма для деления по подпрограммам
         * * "SUM_FOR_SUBPROGRAM_15" - Сумма для подпрограммы 15
         * * "SUM_FOR_SUBPROGRAM" - Сумма для подпрограммы (не 15)
         * * "SUBPROG_DIST" - Колонка, участвующая в распределении
         */
        export type ColSpecType = 'MIN_SUM_FOR_SUBPROGRAM_DIV' | 'MAX_SUM_FOR_SUBPROGRAM_DIV' | 'SUM_FOR_SUBPROGRAM_15' | 'SUM_FOR_SUBPROGRAM' | 'SUBPROG_DIST';

        /**
         * Тип в группе колонок для распределения: TODO old name - TStafftabRep2ColSubprogDistGroupType
         * * `MAX` - Колонка максимума
         * * `SUBPROGRAM_EDITABLE` - Колонка подпрограммы изменяемая
         * * `SUBPROGRAM_READONLY` - Колонка подпрограммы неизменяемая
         */
        export type ColSubprogDistGroupType = 'MAX' | 'SUBPROGRAM_EDITABLE' | 'SUBPROGRAM_READONLY';

        /** Колонка листа отчета (отчеты версии 2) TODO old name - IStafftabRep2Col */
        export interface Col {
            /** ID */
            id: number | null;

            /** Лист отчета */
            sheet: Sheet | null;

            /** Порядковый номер - для сортировки */
            orderNumber: number;

            /** Заголовок на казахском */
            titleKk: string;

            /** Заголовок на русском */
            titleRu: string;

            /** Подзаголовок на казахском */
            subtitleKk: string;

            /** Подзаголовок на русском */
            subtitleRu: string;

            /** Ключ поля (для связи с ["stafftab_rep2_val.field"][StafftabRep2ValEntity.field]) */
            field: string;

            /** Если равно `true`, то в колонке хранятся значения дат */
            dateField: boolean;

            /** Специальный тип */
            specType: ColSpecType | null;

            /** Код подпрограммы */
            subprogram: number | null;

            /** Признак "скрыто" */
            hidden: boolean | null;

            /** Ширина колонки в пикселях, для выгрузки в Excel */
            excelWidth: number | null;

            /** Признак "использовать формат целых чисел" */
            useIntegerFormat: boolean | null;

            /** Код группы колонок для распределения */
            subprogDistGroupCode: string | null;

            /** Тип в группе колонок для распределения */
            subprogDistGroupType: ColSubprogDistGroupType | null;

            /**
             * Признак "колонка-результат"
             *
             * Если значение равно `true`, то сумма значений именно этой колонки сохраняется в `budget_request_form_total`
             *
             * Пустое значение считается равным `false`
             */
            resultCol: boolean;
        }

        /** Лист отчета (отчеты версии 2) TODO old name - IStafftabRep2Sheet */
        export interface Sheet {
            /** ID */
            id: number | null;

            /** Отчет */
            report: Report | null;

            /** Заголовок на казахском */
            titleKk: string;

            /** Заголовок на русском */
            titleRu: string;

            /** Порядковый номер - для сортировки */
            orderNumber: number;

            /** Колонки листа */
            columns: Col[] | null;

            /** Год листа */
            year: number;

            /** Признак "первый год отчета" */
            firstYear: boolean | null;

            /** Код бюджетной подпрограммы */
            budgetSubprogram: number | null;
        }
    }

    /** Типы для распределения */
    export namespace SubprogramDist {
        /** Данные для контроллера расчетов по формам TODO old name - ISubprogramDistData */
        export interface Data {
            /**
             * Колонки
             */
            columns: Array<Version2.Col>;

            /**
             * Строки
             */
            rows: Array<Record<string, unknown>>;
        }

        /** Группа колонок, используемая при распределении по подпрограммам TODO old name - ISubprogramDistColGroup */
        export interface ColGroup {
            /**
             * Код группы
             */
            code: string;

            /**
             * Колонка максимума
             */
            max?: Version2.Col;

            /**
             * Колонка для пустой подпрограммы
             */
            emptySubprogram?: Version2.Col;

            /**
             * Карта колонок для подпрограмм, ключ - код подпрограммы
             */
            columnMapBySubprograms: Map<number | null, Version2.Col>;
        }

        /**
         * Контроллер для расчетов по формам TODO old name - ISubprogramDistFormController
         *
         * Например, используется при изменениях в распределении по подпрограммам
         */
        export interface Controller extends Record<string, unknown> {
            applyChange(columns: Array<Version2.Col>, row: Record<string, unknown>, change: Record<string, unknown>): Record<string, unknown>;
            subprogramsChanged(oldSubprograms: Array<number>, newSubprograms: Array<number>, data: Data): Data;
        }
    }
}

/** Отчет штатного расписания TODO old name - IStafftabReport */
export interface Report {
    /** ID */
    id: number | null;

    /** Дата отчета (на какую дату сформирован отчет) */
    reportDate: string;

    /** Дата формирования (когда сформирован отчет) */
    creationMoment: number;

    /** Форма */
    form: Report.FormKey;

    /** Признак "создан в режиме отладки" */
    debug: boolean;

    /**
     * Какие поля отображать в браузере при отображении данных отчета
     *
     * Содержит названия полей в БД, разделенные запятой
     */
    displayedFields: string;

    /** Функциональная группа; ссылка на dict_ebk_func.gr */
    funcGroup: number | null;

    /** Функциональная подгруппа; ссылка на dict_ebk_func.pgr */
    funcSubgroup: number | null;

    /** Бюджетная программа; ссылка на dict_ebk_func.prg */
    budgetProgram: number | null;

    /** Бюджетная подпрограмма; ссылка на dict_ebk_func.ppr */
    budgetSubprogram: number | null;

    /** Специфика; ссылка на dict_ebk_ek.spf */
    specificity: number | null;

    /**
     * Версия формата отчета; если не заполнено, то это что-то типа первой версии
     *
     * В зависимости от версии данные отчета могут храниться по-разному, например, в других таблицах
     */
    version: number | null;

    /** Признак "деление по подпрограммам" */
    divByPrograms: boolean | null;

    /** Отчет-источник */
    source: Report | null;

    /**
     * Признак "отчет с распределением по подпрограммам"
     *
     * _"null" принимается равным "false"_
     */
    subprogDist: boolean | null;

    /** Код региона */
    region: string | null;

    /** UUID версии бюджета */
    budgetVariant: string | null;

    /** Дата отправки в данных в свод */
    saveDateTotal: number | null;

    /** Версия ШР */
    stVersion: Version | null;

    /** Плановый период */
    planPeriod: string | null;

    /** АБП */
    abpObject: Dict.EbkFunc | null;

    /** Функциональная группа */
    funcGroupObject: Dict.EbkFunc | null;

    /** Функциональная подгруппа */
    funcSubgroupObject: Dict.EbkFunc | null;

    /** Бюджетная программа */
    budgetProgramObject: Dict.EbkFunc | null;

    /** Бюджетная подпрограмма */
    budgetSubprogramObjet: Dict.EbkFunc | null;

    /** Специфика */
    specificityObject: Dict.EbkEk | null;

    /** Регион */
    regionObject: Dict.BudgetRegions | null;

    /** Версия бюджета */
    budgetVariantObject: BudgetVariants | null;

    /** Колонки отчета */
    columns: Array<Report.Version2.Col> | null;

    /** Листы отчета */
    sheets: Array<Report.Version2.Sheet> | null;

    /** Дочерние отчеты */
    reports: Array<Report> | null;

    /** Признак "разрешено сохранение в своде" */
    allowedToSaveInTotal: boolean | null;
}


/**
 * Типы для отчетов штатного расписания, версия 2
 */
export namespace Report2 {
    /**
     * Типы для задач генерации отчетов штатного расписания
     */
    export namespace GenTask {
        /**
         * Статус задачи:
         * * NEW - новая задача (создана, но обработка еще не начиналась);
         * * IN_PROGRESS - задача обрабатывается;
         * * FAILED - задача провалена;
         * * SUCCESSFUL - задача успешно завершена.
         */
        export type Status = 'NEW' | 'IN_PROGRESS' | 'FAILED' | 'SUCCESSFUL';
    }

    /**
     * Задача генерации отчетов штатного расписания
     */
    export interface GenTask {
        /**
         * ID
         */
        id: number | null;

        /**
         * UUID версии бюджета
         */
        budgetVariant: string;

        /**
         * Статус задачи:
         * * "NEW" - новая задача (создана, но обработка еще не начиналась);
         * * "IN_PROGRESS" - задача обрабатывается;
         * * "FAILED" - задача провалена;
         * * "SUCCESSFUL" - задача успешно завершена.
         */
        status: string;

        /**
         * Прогресс выполнения задачи (сколько процентов задачи выполнено).
         *
         * Изменяется и имеет смысл только во время обработки задачи (поле "status" равно "IN_PROGRESS").
         *
         * Значение `null` равнозначно нулю.
         */
        progress: number | null;

        /**
         * Коды бюджетных программ, для которых надо создать отчеты.
         *
         * Если массив пустой или равен NULL, то нужны отчеты для всех бюджетных программ, к которым привязаны сотрудники.
         */
        budgetPrograms: Array<number | null> | null;

        /**
         * Код специфики.
         *
         * Специфики надо искать в таблице "dict_ebk_ek" по полю "spf".
         *
         * Если заполнено, этой спецификой будут заменяться специфики во всех отчетах.
         */
        specificity: number | null;

        /**
         * Номер попытки обработки
         */
        tryNumber: number;

        /**
         * Сообщение.
         *
         * Например, сообщение об ошибке.
         */
        taskMessage: unknown | null;


        /**
         * Версия штатного расписания
         */
        version: Version | null;
    }

    /**
     * Задача генерации отчетов штатного расписания (обертка)
     */
    export interface GenTaskWrap {
        /**
         * Задача
         */
        task: GenTask;

        /**
         * Версия бюджета
         */
        budgetVariant: BudgetVariants;

        /**
         * Статус задачи
         */
        status: GenTask.Status;

        /**
         * Бюджетные программы, для которых надо создать отчеты.
         *
         * Если массив пустой или равен NULL, то нужны отчеты для всех бюджетных программ, к которым привязаны сотрудники.
         */
        budgetPrograms: Array<Dict.EbkFunc> | null;

        /**
         * Специфика.
         *
         * Специфики надо искать в таблице "dict_ebk_ek" по полю "spf".
         *
         * Если заполнено, этой спецификой будут заменяться специфики во всех отчетах.
         */
        specificity: Dict.EbkEk | null;
    }


    export namespace Content {
        export interface Sheet {
            rootColumnGroups: Array<ColumnItem.ColumnGroup>;
            rows: Array<Row>;
        }

        export namespace ColumnItem {
            export interface Base {
                type: string;
                id: number;
                orderNumber: number;
                name: LocalizedString;
                reportTypes: Array<string | null> | null;
            }

            export interface ColumnGroup extends Base {
                type: 'GROUP';
                parentId: number | null;
                hiddableCell: boolean;
                items: Array<ColumnItem>;
            }

            export interface Column extends Base {
                type: 'COLUMN';
                key: string;
                undistributedKey: string;
                unitName: LocalizedString | null;
                aggregation: string | null;
                width: number;
                dataSource: string;
                colType: string | null;
                subprogDistEditable: boolean;
                detailedReportOnly: boolean;
                removeIfNoData: boolean;
                fractionalDigitCount: number | null;
                budgetSubprogramCode: number | null;
                forTotal: boolean;
                code: string | null;
            }
        }

        export type ColumnItem = ColumnItem.ColumnGroup | ColumnItem.Column;

        export interface Row {
            orderNumber: number;
            valueMap: Record<string, DescribedValue>;
        }

        export interface DescribedValue {
            value: Value | null;
            descriptionListMap: Record<string, Array<Description>>;
        }

        export namespace Value {
            export interface Base {
                type: string;
                value: unknown;
            }

            export interface StringValue extends Base {
                type: 'STRING';
                value: LocalizedString;
            }

            export interface NumberValue extends Base {
                type: 'NUMBER';
                value: number;
            }
        }

        export type Value = Value.StringValue | Value.NumberValue;

        export interface Description {
            title: string;
            body: Array<string>;
        }

        export interface Localized<T> {
            defaultValue: T;
            valueMap: Record<string, T>;
        }

        export type LocalizedString = Localized<string>;
    }

    export interface Content {
        sheet1: Content.Sheet;
        sheet2: Content.Sheet;
        sheet3: Content.Sheet;
        additionalData: Utils.WorkbookDto | null;
    }
}

/**
 * Отчет штатного расписания, версия 2
 */
export interface Report2 {
    /**
     * ID
     */
    id: number | null;

    /**
     * UUID версии бюджета.
     *
     * Версии бюджета надо искать в таблице "budget_variants" по полю "variant_uuid".
     */
    budgetVariant: string;

    /**
     * Код вида данных.
     *
     * Виды данных надо искать в таблице "dict_budget_data_types" по полю "code".
     */
    dataType: string;

    /**
     * Код специфики.
     *
     * Специфики надо искать по полю "spf" таблицы "dict_ebk_ek".
     */
    specificity: number;

    /**
     * Код формы (в формате "XX-XXX", где "X" - цифра).
     *
     * Формы надо искать в таблице "dict_calculation_forms" по полю "code".
     */
    form: string;

    /**
     * Код функциональной группы.
     *
     * Функциональные группы надо искать в таблице "dict_ebk_func" по полю "gr".
     */
    funcGroup: number;

    /**
     * Код функциональной подгруппы.
     *
     * Функциональные подгруппы надо искать в таблице "dict_ebk_func" по полю "pgr".
     */
    funcSubgroup: number;

    /**
     * Код АБП.
     *
     * АБП надо искать в таблице "dict_ebk_func" по полю "abp".
     */
    abp: number;

    /**
     * Код бюджетной программы.
     *
     * Бюджетные программы надо искать в таблице "dict_ebk_func" по полю "prg".
     */
    budgetProgram: number;

    /**
     * Признак "расширенный отчет" (могут быть добавлены некоторые колонки)
     */
    detailedReport: number;

    /**
     * Код бюджетной подпрограммы
     *
     * Бюджетные подпрограммы надо искать в таблице "dict_ebk_func" по полю "ppr"
     */
    budgetSubprogram: number | null;

    /**
     * Код региона
     *
     * Регионы хранятся в таблице "dict_budget_regions"
     */
    region: string;

    /**
     * Дата и время создания отчета
     */
    creationMoment: number;

    /**
     * Первый год, коды бюджетных подпрограмм
     */
    y1BudgetSubprograms: Array<number>,

    /**
     * Первый год, есть ошибки
     */
    y1Invalid: boolean;

    /**
     * Второй год, коды бюджетных подпрограмм
     */
    y2BudgetSubprograms: Array<number>;

    /**
     * Второй год, есть ошибки
     */
    y2Invalid: boolean;

    /**
     * Третий год, коды бюджетных подпрограмм
     */
    y3BudgetSubprograms: Array<number>;

    /**
     * Третий год, есть ошибки
     */
    y3Invalid: boolean;

    /** Дата отправки в данных в свод */
    submissionDateToTotal: number | null;

    /**
     * Признак "для первого года есть бюджетные подпрограммы"
     */
    y1BudgetSubprogramsExist: boolean;

    /**
     * Признак "для второго года есть бюджетные подпрограммы"
     */
    y2BudgetSubprogramsExist: boolean;

    /**
     * Признак "для третьего года есть бюджетные подпрограммы"
     */
    y3BudgetSubprogramsExist: boolean;


    /**
     * Версия штатного расписания
     */
    version: Version | null;

    /**
     * Организация
     *
     * _Для передачи на фронт_
     */
    org: Org | null;

    /**
     * Регион
     *
     * _Для передачи на фронт_
     */
    regionObject: Dict.BudgetRegions | null;

    /**
     * Версия бюджета
     *
     * _Для передачи на фронт_
     */
    budgetVariantObject: BudgetVariants | null;
}


/**
 * Типы для отчетов ФЗП
 */
export namespace FzpReport {
    /**
     * Статус генерации отчета.
     *
     * Возможные значения:
     *
     * * 'PLANNED' - "Запланирована";
     * * 'RUNNING' - "Выполняется";
     * * 'FAILED' - "Провалена";
     * * 'FAILED__RETRY_PLANNED' - "Провалена, запланирована для повторной попытки";
     * * 'FINISHED_SUCCESSFULLY' - "Завершена успешно";
     * * 'CANCELLED' - "Отменена".
     */
    export type Status = 'PLANNED' | 'RUNNING' | 'FAILED' | 'FAILED__RETRY_PLANNED' | 'FINISHED_SUCCESSFULLY' | 'CANCELLED';

    /**
     * "Тип форм" ("коллекция форм").
     * Возможные значения:
     * * 'CIVIL' - Гражданские служащие;
     * * 'GOV' - Административные служащие;
     * * 'MVD' - Служащие МВД;
     * * 'ALL' - Все.
     */
    export type ReportType = 'CIVIL' | 'GOV' | 'MVD' | 'ALL';
}

/**
 * Отчет ФЗП
 */
export interface FzpReport {
    /**
     * ID
     */
    id: number | null;

    /**
     * Код региона; соответствует полю "dict_budget_regions.code"
     */
    regionCode: string;

    /**
     * Название региона на казахском; соответствует полю "dict_budget_regions.name_kk"
     */
    regionNameKk: string | null;

    /**
     * Название региона на русском; соответствует полю "dict_budget_regions.name_ru"
     */
    regionNameRu: string | null;

    /**
     * Год отчета
     */
    reportYear: number;

    /**
     * Дата отчета
     */
    reportDate: number | null;

    /**
     * UUID варианта бюджета; соответствует полю "budget_variants.variant_uuid"
     */
    budgetVariantUuid: string | null;

    /**
     * "Тип форм" ("коллекция форм").
     * Возможные значения:
     * * 'CIVIL' - Гражданские служащие;
     * * 'GOV' - Административные служащие;
     * * 'MVD' - Служащие МВД;
     * * 'ALL' - Все.
     */
    reportType: FzpReport.ReportType;

    /**
     * "Новоприбывшие"
     *
     * Если равно `true`, то надо добавлять колонки для ручного ввода
     */
    newArrivals: boolean;

    /**
     * "РБ" ("Республиканский бюджет")
     *
     * Регулирует выбор БПП
     */
    republicBudget: boolean;

    /**
     * ID пользователя (UUID пользователя)
     */
    userId: string;

    /**
     * ФИО пользователя
     */
    userName: string | null;

    /**
     * Дата и время создания задачи генерации отчета
     */
    creationMoment: number;

    /**
     * Статус генерации отчета.
     *
     * Возможные значения:
     *
     * * 'PLANNED' - "Запланирована";
     * * 'RUNNING' - "Выполняется";
     * * 'FAILED' - "Провалена";
     * * 'FAILED__RETRY_PLANNED' - "Провалена, запланирована для повторной попытки";
     * * 'FINISHED_SUCCESSFULLY' - "Завершена успешно";
     * * 'CANCELLED' - "Отменена".
     */
    status: FzpReport.Status;

    /**
     * Запрошена отмена генерации отчета
     */
    cancelRequested: boolean;

    /**
     * Дата и время последнего изменения статуса
     */
    lastStatusMoment: number;

    /**
     * Номер текущей попытки генерации, нумерация с 1.
     *
     * Если равно 0 - значит генерация еще ни разу не запускалась.
     */
    tryNumber: number;

    /**
     * Признак "Отладка"
     */
    debug: boolean;
}


/** Элемент штатного расписания TODO old name - IStaffingTable */
export interface Employee {
    /** ID */
    id: number | null;

    /** Регион */
    region: Dict.BudgetRegions | null;

    /** Дата формирования */
    creationDate: string;

    /** Должность в подразделении */
    pos: Position | null;

    /** Дата приема на государственную службу */
    admissionDate: string | null;

    /** Дата вступления в должность */
    takingOfficeDate: string;

    /** ФИО */
    fullName: string | null;

    /** Признак "Пенсионер */
    retiree: boolean;

    /**
     * Ставка
     *
     * Например, если сотрудник работает на поставки, в поле должно быть число `0.5`
     *
     * Если не заполнено, считается равным `1`
     */
    timeRate: number | null;

    /** Дата решения комиссии по стажу (для уточнения стажа) */
    cdDate: string | null;

    /** Количество лет по решению комиссии (для уточнения стажа) */
    cdYears: number | null;

    /** Количество месяцев по решению комиссии (для уточнения стажа) */
    cdMonths: number | null;

    /** Количество дней по решению комиссии (для уточнения стажа) */
    cdDays: number | null;

    /** Признак "является вакансией" */
    vacancy: boolean | null;

    /** Признак "является вакансией с указанием стажа (количество лет - месяцев)" */
    experienceVacancy: number | null;

    /** Отдел */
    department: Department | null;

    /** Дата начала работы */
    workStartDate: string | null;

    /** Дата окончания работы (дата увольнения) */
    workEndDate: string | null;

    /**
     * Премирование
     *
     * Пустое значение принимается равным "false"
     */
    bonus: boolean | null;

    /**
     * Уровень образования
     */
    eduLevel: Dict.DictEducationLevel | null

    /**
     * Список предметов образования
     */
    eduSubjects: string[] | null

    /** Данные для предопределенных индивидуальных доп. атрибутов */
    eadList: Ead.EadD[] | null;

    /**
     * Образование - настройки сотрудника для фактических часов
     */
    eduWlList:Edu.WlD[] | null

    /** Форма, по которой будет рассчитываться зарплата сотрудника */
    form: Report.FormKey | null;

    /** Бюджетная программа, назначенная сотруднику */
    budgetProgram: number | null;

    /**
     * Позиция для сортировки visibleRows
     */
    serialNumber: number | null;

    /**
     * Тип организации
     */
    orgType: string | null;

    /**
     * Образование, дополнительная бюджетная программа
     */
    eduAdditionalBudgetProgram: number | null;

    /**
     * У этого сотрудника такая должность,
     * которая использует такой поправочный коэффициент гражданской должности,
     * у которого заполнено поле rate_remainder.
     *
     * Сама должность не обязательно гражданская.
     */
    hasCivilPositionRateRemainder?: boolean;

    /**
     * Внештатный сотрудник образования - (преподаватель элективных курсов)
     */
    isAdjunctInstructor: boolean;
}


/**
 * Версия штатного расписания
 */
export interface Version {
    /**
     * ID
     */
    id: number | null;

    /**
     * Код организации, к которой привязывается версия ШР
     */
    orgCode: string;

    /**
     * Год, к которому привязывается версия ШР
     */
    year: number;

    /**
     * Признак "версия ШР архивирована"
     */
    archived: boolean;

    /**
     * Заголовок
     */
    title: string | null;
}


/** Типы-утилиты */
export namespace Utils {
    /**
     * Объект-хранилище инструментов отладки
     */
    export interface DebugUtilObject {
        get<T>(key: string): (T | undefined);
        set(key: string, value: unknown): void;
        remove<T>(key: string): (T | undefined);
        toggleBoolean(key: string): boolean;
    }

    /** Типы для компонента `NumberInput` (modules/budget/staffing-table/NumberInput.vue) */
    export namespace NumberInput {
        /** Настройки форматирования для компонента `NumberInput` (modules/budget/staffing-table/NumberInput.vue) TODO old name - INumberInputFormats */
        export interface Formats {
            defaultFormatter?: Formatter | null;
            getFormatter?: ((locale: string) => Formatter | null) | null;
            localeToFormatterMap?: Record<string, Formatter> | null;

            defaultParser?: Parser | null;
            getParser?: ((locale: string) => Parser | null) | null;
            localeToParserMap?: Record<string, Parser> | null;
        }

        /**
         * Функция форматирования числа в строку TODO old name - TNumberInputFormatter
         *
         * Используется в компоненте `NumberInput` (modules/budget/staffing-table/NumberInput.vue)
         *
         * @param value Значение, которое нужно отформатировать
         *
         * @returns Форматирование значение
         */
        export type Formatter = (value: number | null) => string | null;

        /**
         * Функция чтения числа из строки TODO old name - TNumberInputParser
         *
         * Используется в компоненте `NumberInput` (modules/budget/staffing-table/NumberInput.vue)
         *
         * @param value Строка, из которой надо получить число
         *
         * @returns Прочитанное число
         */
        export type Parser = (value: string | null) => number | null;
    }

    /** Список элементов вместе с информацией для навигации по страницам TODO old name - IPaginationList */
    export interface PaginationList<T> {
        /** Кол-во элементов на странице */
        itemsPerPage: number;

        /**
         * Текущая страница
         *
         * Нумерация с 0
         */
        page: number;

        /** Общее кол-во элементов */
        itemCount: number;

        /** Общее кол-во страниц */
        pageCount: number;

        /** Элементы для текущей страницы */
        items: T[];
    }

    /**
     * Запрашиваемая навигация по страницам
     */
    export interface RequestedPagination {
        /**
         * Количество элементов на странице
         */
        itemsPerPage: number;

        /**
         * Индекс страницы, нумерация с нуля
         */
        page: number;
    }

    /**
     * Ключи шаблонов
     */
    export type TemplateKey = 'variant-budget-reports' | 'form-reports' | 'specificity-reports' | 'budget-program-reports' | 'variant-budget-staff-version-reports';

    export interface WorkbookDto {}
}